import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SigninComponent } from './signin/signin.component';
import { MdLayoutsComponent } from './md/md-layouts/md-layouts.component';
import { SdpLayoutsComponent } from './sdp/sdp-layouts/sdp-layouts.component';
import {RouteResolver} from './resolvers/route.resover'
import {ServerDownComponent} from './server-down/server-down.component'
const routes: Routes = [
  // ************************************SIMRAN CODE START*********************************
  { path : "sdp" , component: SdpLayoutsComponent , loadChildren:() => import('./sdp/sdp-layouts/sdp-layouts.module').then( m => m.SdpLayoutsModule)},
  { path : "md" , component: MdLayoutsComponent , loadChildren:() => import('./md/md-layouts/md-layouts.module').then( m => m.MdLayoutsModule)},
  // **************************************SIMRAN CODE END*************************************

      {
          "path": "login",
          "component": SigninComponent
      },
      {
          "path": "**",
          "redirectTo": "error_404",
          "pathMatch": "full"
      },
      {
        "path": "error",
        "component": ServerDownComponent
    },
      {
        'path' : '' , 'redirectTo': 'index', 'pathMatch': 'full'
      }
  ];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
  providers:[RouteResolver]
})
export class AppRoutingModule { }
